<template>
  <el-dialog
    :title="model.id ? '编辑复合片' : '添加复合片'"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="复合片" prop="commodity_id">
        <CommoditySelect
          :category="2"
          v-model="model.commodity_id"
        ></CommoditySelect>
      </el-form-item>
      <!-- <el-form-item label="规格" prop="specification">
        <el-input v-model="model.specification"></el-input>
      </el-form-item> -->
      <el-form-item label="倒角" prop="chamfering">
        <el-input v-model="model.chamfering"></el-input>
      </el-form-item>
      <!-- <el-form-item label="编码" prop="serial_number">
        <el-input v-model="model.serial_number"></el-input>
      </el-form-item> -->
      <el-form-item label="直径" prop="diameter">
        <el-input v-model.number="model.diameter"></el-input>
      </el-form-item>
      <el-form-item label="齿形" prop="tooth_type">
        <el-input v-model="model.tooth_type"></el-input>
      </el-form-item>
      <el-form-item label="等级" prop="grade">
        <el-input v-model="model.grade"></el-input>
      </el-form-item>
      <!-- <el-form-item label="数量" prop="number">
        <el-input
          v-model="model.number"
          type="number"
          min="1"
          step="1"
        ></el-input>
      </el-form-item> -->
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { pdcNew, pdcUpdate } from '@/service/getData'
import CommoditySelect from './select/commodity_select.vue'

export default {
  components: {
    CommoditySelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  created() {},
  data() {
    return {
      visible: this.show,
      loading: false,
      pdcs: [],
      rules: {
        commodity_id: [{ required: true, message: '请选择分类' }],
        specification: [{ required: true, message: '请填写规格' }],
        chamfering: [{ required: true, message: '请填写倒角' }],
        serial_number: [{ required: true, message: '请填写规编码' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await pdcUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await pdcNew(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>